import mustache from "mustache";
import { VentaAnimalesResponse } from "../../../../../modulos/pesaje/ganaderia/response/VentaAnimalesResponse";
import { formatFechaCorta } from "../../../../../utils/fechaUtils";
import { _miles } from "../../../../../utils/numberUtils";
import { IConnectRender } from "../../../../definitions/IConnectRender";
import template from "./ventaListItemTemplate.html";

mustache.parse(template);

/** Contador para ids únicos por instancia. */
let VENTA_ITEM_ID = 0;

/** Acciones de una fila de venta. */
export type VentaListItemActions = {
  /** Ver el detalle de la venta. */
  onView: (venta: VentaAnimalesResponse) => void;
  /** Editar la venta. */
  onEdit: (venta: VentaAnimalesResponse) => void;
  /** Eliminar la venta. */
  onDelete: (venta: VentaAnimalesResponse) => void;
};

/** Fila de la lista de ventas (Render/Connect): avatar (código), potrero de
 *  salida, fecha/cantidad, peso total, valor total y acciones ver/editar/eliminar. */
export class VentaListItemRender implements IConnectRender {
  /** Id único de la instancia (para los ids del DOM). */
  private readonly _itemId: number;

  /**
   * @param _venta   Venta a mostrar.
   * @param _actions Handlers de ver/editar/eliminar.
   */
  constructor(
    private readonly _venta: VentaAnimalesResponse,
    private readonly _actions: VentaListItemActions,
  ) {
    VENTA_ITEM_ID += 1;
    this._itemId = VENTA_ITEM_ID;
  }

  /** HTML de la fila. */
  render(): string {
    const v = this._venta;
    return mustache.render(template, {
      id: this._itemId,
      codigo: v.codigo,
      lote: v.loteSalida.nombreLote,
      secondary: [
        formatFechaCorta(v.fechaVenta),
        `${v.cantidadAnimales} animales`,
      ].join(" · "),
      pesoTotal: _miles(v.pesoTotal),
      valorTotal: _miles(v.precioTotal),
    });
  }

  /** Cablea los 3 botones de acción. */
  connect(): void {
    this._view = document.getElementById(`venta-view-${this._itemId}`);
    this._edit = document.getElementById(`venta-edit-${this._itemId}`);
    this._delete = document.getElementById(`venta-delete-${this._itemId}`);
    this._view?.addEventListener("click", this._onView);
    this._edit?.addEventListener("click", this._onEdit);
    this._delete?.addEventListener("click", this._onDelete);
  }

  /** Libera los listeners. */
  dispose(): void {
    this._view?.removeEventListener("click", this._onView);
    this._edit?.removeEventListener("click", this._onEdit);
    this._delete?.removeEventListener("click", this._onDelete);
  }

  private _view: HTMLElement | null = null;
  private _edit: HTMLElement | null = null;
  private _delete: HTMLElement | null = null;

  private _onView = (): void => this._actions.onView(this._venta);
  private _onEdit = (): void => this._actions.onEdit(this._venta);
  private _onDelete = (): void => this._actions.onDelete(this._venta);
}
